(function () {
  'use strict';

  function setupGallery(gallery) {
    if (!gallery || gallery.dataset.eeGalleryRecoveryReady === 'true') return;
    gallery.dataset.eeGalleryRecoveryReady = 'true';

    var viewer = gallery.querySelector('[data-gallery-viewer]');
    var navigation = gallery.querySelector('[data-gallery-navigation]');
    var scroller = gallery.querySelector('[data-gallery-scroller]');
    if (!viewer || !navigation || !scroller) return;

    var figures = Array.prototype.slice.call(viewer.querySelectorAll('[data-gallery-figure]'));
    var thumbs = Array.prototype.slice.call(navigation.querySelectorAll('[data-gallery-thumbnail]'));
    if (figures.length <= 1 || thumbs.length <= 1) {
      navigation.classList.remove('loading');
      return;
    }

    // Never leave additional product media visually inaccessible while JS initializes.
    navigation.style.opacity = '1';

    function selectedIndex() {
      var selected = viewer.querySelector('[data-gallery-selected="true"]');
      var index = selected ? parseInt(selected.getAttribute('data-gallery-index'), 10) : 0;
      return isNaN(index) ? 0 : index;
    }

    function selectFallback(index) {
      if (index < 0) index = figures.length - 1;
      if (index >= figures.length) index = 0;

      figures.forEach(function (figure, i) {
        var active = i === index;
        figure.setAttribute('data-gallery-selected', active ? 'true' : 'false');
        figure.setAttribute('aria-hidden', active ? 'false' : 'true');
        figure.classList.toggle('is-selected', active);
      });

      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.setAttribute('data-gallery-selected', active ? 'true' : 'false');
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      // Let the selected natural-ratio image establish the viewer height.
      viewer.style.height = '';
    }

    function activateFallback() {
      // Empire removes "loading" after successfully initializing the gallery.
      // Only take over when that never happened.
      if (!navigation.classList.contains('loading')) return;

      navigation.classList.remove('loading');
      navigation.style.opacity = '1';
      gallery.classList.add('ee-gallery-fallback-active');
      selectFallback(selectedIndex());

      scroller.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-gallery-thumbnail]');
        if (!thumb || !scroller.contains(thumb)) return;
        event.preventDefault();
        var index = parseInt(thumb.getAttribute('data-gallery-index'), 10);
        if (!isNaN(index)) selectFallback(index);
      });

      if (!viewer.querySelector('.ee-gallery-fallback-controls')) {
        var controls = document.createElement('div');
        controls.className = 'ee-gallery-fallback-controls';

        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'ee-gallery-fallback-button ee-gallery-fallback-prev';
        prev.setAttribute('aria-label', 'Previous product image');
        prev.innerHTML = '&#8249;';

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'ee-gallery-fallback-button ee-gallery-fallback-next';
        next.setAttribute('aria-label', 'Next product image');
        next.innerHTML = '&#8250;';

        prev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          selectFallback(selectedIndex() - 1);
        });

        next.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          selectFallback(selectedIndex() + 1);
        });

        controls.appendChild(prev);
        controls.appendChild(next);
        viewer.appendChild(controls);
      }
    }

    // Give Empire and app embeds ample time to initialize first.
    window.setTimeout(activateFallback, 2200);
  }

  function init() {
    document.querySelectorAll('[data-product-gallery]').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Quick Shop / theme-editor sections may be inserted after the initial page load.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
